import {useEffect, useState} from "react";
import {apiClient} from "../providers/apiClient";

const fetchComplaints = (params) => {
    return apiClient.get("/api/Report/list", {params});
}

const FILTERS_DEFAULT = {
    companyId: null,
    reporterId: null,
    parentId: null,
    search: null,
    dateFrom: null,
    dateTo: null,
    status: null,
    isPublic: null,
    sectorId: null,
    typeId: null,
    orderBy: null,
    orderDirection: null,
    pageSize: 6,
    pageNumber: 1,
}

const useComplaints = (initialFilters) => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({ hasNext: false, hasPrevious: false, pageSize: 6, pageNumber: 1});
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({...FILTERS_DEFAULT, ...initialFilters});

    const nextPage = () => {
        if(!pagination.hasNext) return;

        setFilter("pageNumber", pagination.pageNumber + 1);
    }

    const previousPage = () => {
        if(!pagination.hasPrevious) return;

        setFilter("pageNumber", pagination.pageNumber - 1);
    }
    
    const setFilter = (filterName, value) => {
        setFilters(prev => {
            return {
                ...prev,
                [filterName]: value
            }
        })
    }

    const resetFilters = () => {
        setFilters({...FILTERS_DEFAULT});
    }
    
    useEffect(() => {
        setLoading(true);
        
        fetchComplaints(filters).then(response => {
            const data = response.data;
            setData(data.items);
            
            setPagination(prev => ({
                pageSize: filters.pageSize,
                pageNumber: filters.pageNumber,
                hasNext: data.hasNext,
                hasPrevious: data.hasPrevious,
            }));
            
        }).catch(e => {
            setError(e.message);
        }).finally(() => {
            setLoading(false)
        });
        
    }, [filters]);

    const refresh = () => {
        fetchComplaints(filters).then(response => {
            const data = response.data;
            setData(data.items);
            setPagination({
                hasNext: data.hasNext,
                hasPrevious: data.hasPrevious,
            });
        }).catch(e => {
            setError(e.message);
        }).finally(() => {
            setLoading(false)
        });
    }
    
    return {
        data, 
        error,
        pagination, 
        loading,
        setFilter,
        filter: filters,
        nextPage,
        previousPage,
        refresh,
        resetFilters
    }
    
}

export default useComplaints;